/** @typedef {'idle' | 'connecting' | 'connected' | 'reconnecting' | 'disconnected' | 'error'} SignalRConnectionStatus */

export const SIGNALR_STATUS = {
  IDLE: "idle",
  CONNECTING: "connecting",
  CONNECTED: "connected",
  RECONNECTING: "reconnecting",
  DISCONNECTED: "disconnected",
  ERROR: "error",
};
